export default __webpack_public_path__ + "static/media/3.07e357f5.jpg";